
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'DCACGOHINHIE',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DCACGOHINHIE.vue